document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('pincodeForm');
    const pincodeInput = document.getElementById('pincode');
    const pincodeError = document.getElementById('pincodeError');
    const pincodeSuccess = document.getElementById('pincodeSuccess');
    const pincodeFail = document.getElementById('pincodeFail');
    const addToCartButton = document.getElementById('AddToCart');
    const buyNowButton = document.querySelector('.shopify-payment-button__button');
    const dummyBuyNowButton = document.getElementById('dummyBuyNowButton');

    const DELHIVERY_URL = 'https://redchiefedd.marmeto.com/api/delhivery/serviceability';
    const BLUEDART_URL = 'https://redchief.technogious.com/api/bluedart/serviceability';

    function hideAllMessages() {
        pincodeError.style.display = 'none';
        pincodeSuccess.style.display = 'none';
        pincodeFail.style.display = 'none';
    }

    function showSuccess() {
        pincodeSuccess.style.display = 'block';
        if (dummyBuyNowButton) dummyBuyNowButton.style.display = 'none';
        if (buyNowButton) buyNowButton.style.display = 'block';
    }

    function showFail(message) {
        pincodeFail.textContent = message || 'Sorry, we cannot deliver to this pincode.';
        pincodeFail.style.display = 'block';
        if (dummyBuyNowButton) dummyBuyNowButton.style.display = 'inline-block';
        if (buyNowButton) buyNowButton.style.display = 'none';
    }

    // ✅ Hide real Shopify Buy Now button initially
    if (buyNowButton) buyNowButton.style.display = 'none';

    // Checks Delhivery. Returns true if serviceable, false otherwise.
    async function checkDelhivery(pincode) {
        try {
            const response = await fetch(DELHIVERY_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ delivery_postcode: pincode })
            });
            const data = await response.json();
            const deliveryInfo = data.data?.data?.delivery_codes?.[0]?.postal_code;
            if (deliveryInfo && (deliveryInfo.cash === "Y" || deliveryInfo.pre_paid === "Y")) {
                return true;
            }
            return false;
        } catch (error) {
            console.error("Delhivery check failed:", error);
            return false;
        }
    }

    // Checks Bluedart. Returns true if serviceable, false otherwise.
    async function checkBluedart(pincode) {
        try {
            const response = await fetch(BLUEDART_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ pincode: pincode })
            });
            if (!response.ok) {
                // e.g. 500 Serviceability check failed
                return false;
            }
            const data = await response.json();
            if (data.IsError === false) {
                return true;
            }
            return false;
        } catch (error) {
            console.error("Bluedart check failed:", error);
            return false;
        }
    }

    // Master function: tries Delhivery first, falls back to Bluedart.
    // Returns true/false and updates UI + isPincodeValid.
    async function checkPincode(pincode) {
        hideAllMessages();

        if (!/^\d{6}$/.test(pincode)) {
            pincodeError.textContent = 'Please enter a valid 6-digit pincode.';
            pincodeError.style.display = 'block';
            return false;
        }

        const delhiveryOk = await checkDelhivery(pincode);
        if (delhiveryOk) {
            showSuccess();
            return true;
        }

        const bluedartOk = await checkBluedart(pincode);
        if (bluedartOk) {
            showSuccess();
            return true;
        }

        showFail('Sorry, we cannot deliver to this pincode.');
        return false;
    }

    // Handle pincode form submission
    form.addEventListener('submit', async function(event) {
        event.preventDefault();
        const pincode = pincodeInput.value.trim();
        await checkPincode(pincode);
    });

    // Add to cart button check
    addToCartButton.addEventListener('click', async function(event) {
        event.preventDefault(); 
        const pincode = pincodeInput.value.trim();
        const isValid = await checkPincode(pincode);
        if (isValid) {
            addToCartButton.removeEventListener('click', arguments.callee);
            addToCartButton.click(); // Add to cart click
        }
    }, { once: false });

    // Dummy Buy Now button check
    if (dummyBuyNowButton) {
        dummyBuyNowButton.addEventListener('click', async function(event) {
            event.preventDefault();
            const pincode = pincodeInput.value.trim();
            await checkPincode(pincode);
        });
    }
});